import { useState } from 'react';
import { API } from '../../../api/api';
import { URLS } from '../../../api/urls';
import { DeleteConfirmationModal } from '../../../components/DeleteConfirmationModal/DeleteConfirmationModal';
import { ALERT_TEXT } from '../../../constants/content';
import { useAlert } from '../../../context/Alert.context';

interface DeletePageModalProps {
  open: boolean;
  onClose: () => void;
  mailId: string;
  updateMailsAfterDelete: (mailId: string) => void;
}

export const DeleteMailModal = ({
  open,
  onClose,
  mailId,
  updateMailsAfterDelete,
}: DeletePageModalProps) => {
  const [loading, setLoading] = useState(false);
  const { showAlert } = useAlert();

  const onDelete = () => {
    setLoading(true);
    API.delete(`${URLS.MAIL}/${mailId}`)
      .then(() => {
        updateMailsAfterDelete(mailId);
        onClose();
        showAlert({
          message: ALERT_TEXT.MAIL_DELETE_SUCCESS,
          severity: 'success',
        });
      })
      .catch((e) => showAlert({ message: e.message, severity: 'error' }))
      .finally(() => setLoading(false));
  };

  return (
    <DeleteConfirmationModal
      loading={loading}
      onClose={onClose}
      open={open}
      titleItem={'mail'}
      onDelete={onDelete}
    />
  );
};
